<template>
<div>

<spinner v-bind:spinner='spinner'></spinner>

  <div class="row mt-3">

  <div class="col">

  <div class="table-wrapper-scroll-y my-custom-scrollbar">              
  <table class="table table-hover table-sm mb-0" id="table">
    <thead >
      <tr class="table-primary">
        <th>
         # 
        </th>  
       
        <th>
            BARCODE GESTIONALE
        </th>
        <th>
            COLORE
        </th>
        <th>
            MISURA
        </th>
                  
        <th>
            BARCODE SUPPLIER
        </th>     
             
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, index) in filteredItems" :key="index">
        <td>
          {{index+1}}
        </td>

        
          
        <td>
         {{item.barcode}}
        </td>
        <td>
         {{item.color}}
        </td>
        <td>
         {{item.size}}
        </td>


        <td>
          <input v-model = "item.supplier_barcode" class="form-control bold"  v-bind:id="'id_' + index " type="number"> 
         
        </td>

        
      </tr>
    </tbody>
  </table> 
 </div>

  <label class="mt-4" for="cerca">
    <i style="color:navy" class="fas fa-filter mr-2" aria-hidden="true"></i>
    <strong>Filtra</strong></label>
  <input class="form-control" type="text" name="query" v-model="filterKey">
  <alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>

  <button :disabled="spinner==true"  @click="saveData()"  class="btn btn-primary float-right mr-2 mt-2">
     <i class="fas fa-edit mr-2 " aria-hidden="true"></i>
    MODIFICA
   
</button>
</div>


</div>

  </div>

<!--
</div>
</div>
-->
</template>

<script>
import api                from '@/api';
import { mapGetters }     from 'vuex';

import spinner            from '@/components/common/Spinner.vue';
import alertBox           from '@/components/common/AlertBox.vue';

export default {
  props : ['item'],
   components: {
     spinner,alertBox
   
  },
  
  data () {
    return {

 
    msg            :{
      title        : ''
    }, 

    
    items          : [],
    spinner        : false,
    filterKey      : '',
    

    }
  },
  computed: 
  {  
    ...mapGetters(['company']),

    filteredItems : function () 
      {
        var filterKey = this.filterKey && this.filterKey.toLowerCase()
        var items = this.items
        if (filterKey) {
        items = items.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
        return items
     },
     

  },
  watch: 
  {
    
  },
      
  mounted()
  {
    

    this.getData()

  },
  created()  
  {

    
   
  }, 
  methods: 
    {
      
     async checkBarcodeList()
     {

             
        this.spinner = true          
        const data     = {
          'companyId' : this.company.Id,
          'productId' : this.item.productId, 'body' : this.items}
          const sp       = {'sp':'spCompanySupplierBarcodes'}  
          
            var json     = Object.assign(data, sp)
            
         return new  Promise( async (resolve, reject)  =>  {
         await api.post(json).then(res => {
                   
          if(res.status==200)
            {
               
              resolve(res.data.recordsets[0])               
              
            }
           else if(res.status==500)
           {
               
              reject(res.data)                
                    
           } 
           else
            { 

              reject(res)

              
            } 
          

          }).catch(err => {
              
              
               reject(err.message) 
              
              
          }).finally(() => {
            this.spinner = false
        });
        

         })


       
     },
     findDuplicates(arr) 
        {
         return arr.filter((currentValue, currentIndex) =>
         arr.indexOf(currentValue) !== currentIndex);
        },
       
     async saveData()
      {
         
        this.msg.title = ''     
        let array = []
        this.items.forEach(item => {
          if(item.supplier_barcode)
          {
            array.push(item.supplier_barcode)
          }
        }) 
        
        try {
        
          let data = await this.checkBarcodeList()
          
          let barcode = {}
                    
          data.forEach(item => {
           
            if(item.productId != this.item.productId )
            {
              barcode = item      
            }
           
          })
          
          
          if(barcode.productId && barcode.sku != this.item.sku)
          {
            this.msg.title = 'ATTENZIONE '
            this.msg.body = 'Il barcode fornitore ' + barcode.supplier_barcode + ' è già abbinato al prodotto con ID ' + barcode.productId 
            this.msg.type = 1              
            return
          }  
          
          let duplicates = this.findDuplicates(array)
          if(duplicates.length > 0)
          {
            let eanList = ''
            this.msg.title = 'ATTENZIONE '
            duplicates.forEach(item=>{
              eanList = eanList + item + ','
            })
            this.msg.body = 'EAN ' + eanList + ' duplicato/i.' 
            this.msg.type = 1              
            return
          }
       }
       catch(err)
       {
          this.msg.title = 'ATTENZIONE '
          this.msg.body = err
          this.msg.type = 1                
          return
       } 
          
        

        this.spinner = true          
        const data     = {
          'companyId' : this.company.Id,
          'productId':this.item.productId, 'body' : this.items}
        const sp       = {'sp':'spUpdateSupplierBarcodes'}                
        const json     = Object.assign(data, sp)
        await api.post(json).then(res => {
          
         
          if(res.status==200)
            {
              

              this.msg.title = 'ASSOCIAZIONE BARCODE SUPPLIER'
              this.msg.body = 'Modifica effettuata.'
              this.msg.type = 0              
              
            }
           else if(res.status==500)
           {
                

              this.msg.title = 'ATTENZIONE ***'
              this.msg.body = res.data
              this.msg.type = 1                
                
                    
           } 
           else
            { 
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res
              this.msg.type = 1                 
            } 
          

          }).catch(err => {
              
              
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.nessage
              this.msg.type = 1                 

              
          }).finally(() => {
          this.spinner = false
        });
        


        

      },
    
    
      
      async getData() 
      {


        this.spinner = true          
        const data     = {'productId' : this.item.productId}
        const sp       = {'sp':'spSupplierBarcodes'}        
        
        const json     = Object.assign(data, sp)
        await api.post(json).then(res => {
          
         
          if(res.status==200)
            {
              this.items = res.data.recordsets[0] 
               this.$nextTick().then(function () {
              
                document.getElementById("id_0").focus();
                
               })     
            }
           else if(res.status==500)
           {
                

              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data
              this.msg.type = 1                
                
                    
           } 
           else
            { 
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res
              this.msg.type = 1                 
            } 
          

          }).catch(err => {
              
              
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.nessage
              this.msg.type = 1                 

              
          }).finally(() => {
          this.spinner = false
        });
        


        
    
        

      }
    },
    
}
</script>

<style scoped>
h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
p{
  font-family: 'Roboto Condensed';
  font-size: 25px;
}
.my-custom-scrollbar {
position : relative;
height   : 600px;
overflow : auto;
}
.table-wrapper-scroll-y {
display  : block;
}
a{
  font-family : 'Roboto Condensed';
  font-size   : 25px;
  color       : red
}

input[type='checkbox'] {
 
  cursor         : pointer;
 
}
.table th:first-child
{
  border-radius : 0 0 0 8px;
}
.table th:last-child
{
  border-radius : 0 8px 0 0;  
}
.table thead  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : hwb(45 4% 9%);  
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;
   

 }

     .bold
    {
        font-weight  : bold;
    }
    input[type=number] {
  border: 1px solid;
 
}
</style>